@if (this.paymentInfo != null) {
    <hr>
    <div>
        <label class="header-label"><mat-icon style="vertical-align: middle; margin-right: 8px;">payment</mat-icon>{{ 'ai.paymentInfo' | transloco }}:</label>
        <label style="font-size: 12px; margin-left: 20px">{{paymentInfo?.paymentId}}</label>
        <table>
            <tr>
                <td>Due date:</td>
                <td>{{paymentInfo?.paymentDate}}</td>
                <td>Terms:</td>
                <td>{{paymentInfo?.terms}} months</td>
                <td>Pricing Method:</td>
                <td>{{PricingMethods[paymentInfo?.pricingMethod]}}</td>
                <td>Stations:</td>
                <td>{{paymentInfo?.stations}}</td>
            </tr>
            <tr>
                <td>Amount:</td>
                <td>${{paymentInfo?.amountBefore}}</td>
                @if (paymentInfo?.discount > 0) {
                    <td>Discount:</td>
                    <td>{{paymentInfo?.discount}}%</td>
                    <td>Amount after discount:</td>
                    <td>${{paymentInfo?.amount}}</td>
                }
            </tr>
        </table>
    </div>
    <hr>
    @if (!paid) {
        <div style="width: 100%; text-align: center;">
            <button style="width: 200px; height: 60px; color: white; background-color: green" (click)="onMakePayment()" class="subButton" mat-raised-button [disabled]="!canMakePayment()"><mat-icon>account_balance_wallet</mat-icon>{{ 'ai.makePayment' | transloco }}</button>
        </div>
    }
    @else {
        <div style="width: 100%; text-align: center; font-size: 24px; color: green; font-weight: bold;"><mat-icon style="vertical-align: middle; margin-right: 8px; font-size: 32px; width: 32px; height: 32px;">check_circle</mat-icon>{{ 'ai.paymentSucceeded' | transloco }}</div>
    }

}
